export const exploitations = [
    {
       'id': 1,
       'type': 'FOREST',
       'checked': false
    },
    {
       'id': 2,
       'type': 'AGRICULTURAL',
       'checked': false
    },
    {
       'id': 3,
       'type': 'LIVESTOCK',
       'checked': false
    },
];
